







































































import { Component, Vue } from 'nuxt-property-decorator'
import PageSeoMixin from '~/mixins/PageSeoMixin'
import SectionLead from '~/components/Section/SectionLead.vue'
import ContactForm from '~/components/Other/ContactForm.vue'
import ContactOfficeDetails from '~/components/Other/ContactOfficeDetails.vue'

@Component({
  name: 'ContactUsPage',
  components: {
    SectionLead,
    ContactForm,
    ContactOfficeDetails
  },
  mixins: [PageSeoMixin]
})
export default class extends Vue {
  imgSrc = require(`~/assets/img/contact-us/i/undraw_contact_us_15o2.svg`)

  get officeList() {
    const items = [
      {
        Key: 'CZ',
        Img: 'dimitry-anikin-M7sdBYlrw9w-unsplash.jpg'
      },
      {
        Key: 'JP',
        Img: 'charles-postiaux-VsGyECexVy4-unsplash.jpg'
      },
      {
        Key: 'SE',
        Img: 'jessica-guzik-Fuj145tMO84-unsplash.jpg'
      }
    ]
    return items.map((item) => ({
      Key: item.Key,
      Img: require(`~/assets/img/contact-us/${item.Img}`),
      // @ts-ignore
      ...this.$t(`ContactInfo.Offices.List.${item.Key}`)
    }))
    // imgSrc = require(`~/assets/img/faq/i/undraw_faq_rjoy.svg`)
    // return this.$tt('List')
  }
}
